export class CustomException extends Error {
	public readonly statusCode: number;
	public readonly friendlyKey?: string;
	public readonly keys?: Record<string, string>;

	constructor(
		message: string,
		statusCode: number = 500,
		friendlyKey: string,
		keys?: Record<string, string>
	) {
		super(message); // Llama al constructor de Error
		this.statusCode = statusCode; // Código de estado HTTP o personalizado
		this.friendlyKey = friendlyKey; 
		this.keys = keys;

		// Ajusta el stack trace para que apunte al lugar correcto
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, this.constructor);
		}
	}

	public toJSON(): object {
		return {
			message: this.message,
			statusCode: this.statusCode,
			friendlyKey: this.friendlyKey,
			keys: this.keys,
		};
	}
}
